<template>
  <div class="noticeMailSetting">
    <setting-header />
    <v-divider class="noticeMailSetting_divider" />
    <section class="noticeMailSetting_conent">
      <section v-if="loading" class="noticeMailSetting_loading">
        <v-progress-circular
          :size="30"
          :width="2"
          indeterminate
        ></v-progress-circular>
      </section>
      <section class="noticeMailSetting_switch">
        <h2>{{ title }}</h2>
        <v-switch
          :input-value="mail[0]"
          :ripple="false"
          dense
          @change="handleSwitch($event, 0)"
        ></v-switch>
      </section>
      <section v-if="mail[0]" class="noticeMailSetting_list">
        <section
          v-for="(item, i) in list"
          :key="i"
          class="noticeMailSetting_switch noticeMailSetting_switch-item"
        >
          <h2>{{ item.label }}</h2>
          <v-switch
            :input-value="mail[item.id]"
            :ripple="false"
            dense
            @change="handleSwitch($event, item.id)"
          ></v-switch>
        </section>
      </section>
    </section>
    <v-divider class="noticeMailSetting_divider" />
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import SettingHeader from '../SettingHeader.vue';
import isEqual from 'fast-deep-equal';

export default {
  name: 'NoticeMailSetting',
  components: {
    SettingHeader,
  },
  beforeRouteLeave: async function (to, from, next) {
    if (to.name !== 'settings-notice-main' || !this.isChanged) {
      // only update when is edit mode and user navigating to settings-notice-main page

      next();
      return;
    }
    await this.updateNoticeSettings();
    next();
  },
  data() {
    return {
      dialogMessageText: '',
      oldMail: [],
      list: [
        {
          id: '1',
          label: 'イベント検知',
          value: false,
        },
        {
          id: '2',
          label: 'カメラ異常検知',
          value: true,
        },
        {
          id: '3',
          label: 'ビデオクリップ作成完了',
          value: true,
        },
      ],
      enabled: true,
      title: 'メール通知を許可する',
    };
  },
  computed: {
    ...mapState({
      noticeSettings: (state) => state.settings.noticeSettings,
      noticeSettingsLoading: (state) => state.settings.noticeSettingsLoading,
    }),
    mail() {
      return this.noticeSettings.mail;
    },
    loading() {
      return this.noticeSettingsLoading;
    },
    isChanged() {
      return !isEqual(this.mail, this.oldMail);
    },
  },
  mounted() {
    this.oldMail = [...this.mail];
  },
  methods: {
    ...mapActions('settings', ['setNoticeSetting', 'updateNoticeSettings']),
    handleSwitch(status, index) {
      const newMail = [...this.mail];
      newMail.splice(index, 1, status);
      this.setNoticeSetting({ key: 'mail', value: newMail });
    },
  },
};
</script>

<style lang="scss">
.noticeMailSetting {
  &_conent {
    position: relative;
  }
  &_loading {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    position: absolute;
    background-color: #ffffffab;
    z-index: 1;
  }
  &_divider {
    margin-top: 15px;
    &.theme--light.v-divider {
      border-color: #ccc;
    }
  }
  &_switch {
    display: flex;
    width: 260px;
    justify-content: space-between;
    margin-top: 15px;
    h2 {
      font-size: 14px;
      font-weight: bold;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.5;
      letter-spacing: normal;
      text-align: left;
      color: #4b4b4b;
    }
    &-item {
      padding-left: 30px;
      margin-top: 32px;
    }
  }
  &_list {
  }
  .v-input.v-input--switch {
    margin-top: 0;
    padding-top: 0;
    display: inline-block;
    &.v-input--is-disabled {
      opacity: 0.4;
    }
    .v-input__control {
      .v-messages {
        display: none;
      }

      .v-input__slot {
        margin-bottom: 0;

        .v-input--selection-controls__input {
          .v-input--switch__track {
            border-radius: 15px;
            width: 42px;
            height: 22px;
            left: -1px;
            position: absolute;
            opacity: 1;
            right: 2px;
            top: calc(50% - 11px);
            color: #cccccc !important;
          }

          .v-input--switch__track.primary--text {
            color: #0075c2 !important;
          }

          .v-input--switch__thumb {
            color: #ffffff !important;
            width: 20px;
            height: 20px;
            box-shadow: -3px 0 3px 0 rgba(0, 0, 0, 0.1);
          }
        }

        .theme--light.v-label {
          font-size: 12px;
          font-weight: 500;
          font-stretch: normal;
          font-style: normal;
          letter-spacing: 0.6px;
          color: #666;
        }
      }
    }
  }
}
</style>
